export enum PaymentConfig {
	CommercialConditions = "commercial-conditions",
}
